/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminTimeframe } from '../models/AdminTimeframe';
import type { AdminTimeframeAppend } from '../models/AdminTimeframeAppend';
import type { AdminTimeframeEnd } from '../models/AdminTimeframeEnd';
import type { AdminTimeframePrepend } from '../models/AdminTimeframePrepend';
import type { AdminTimeframeStart } from '../models/AdminTimeframeStart';
import type { AdminTimeframeUpdate } from '../models/AdminTimeframeUpdate';
import type { TimeframeAssignmentApply } from '../models/TimeframeAssignmentApply';
import type { TimeframeAssignmentApplyResult } from '../models/TimeframeAssignmentApplyResult';
import type { TimeframeAssignmentReport } from '../models/TimeframeAssignmentReport';
import type { TimeframeAssignmentRevertResult } from '../models/TimeframeAssignmentRevertResult';
import type { TimeframeAssignmentVerifyResult } from '../models/TimeframeAssignmentVerifyResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminTimeframesService {

    /**
     * List Admin Timeframes
     * Every timeframe, sorted by start, including hidden ones.
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static listAdminTimeframesApiV1AdminTimeframesGet(): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/timeframes',
        });
    }

    /**
     * Append Timeframe
     * Add a timeframe after the last one. It starts where the last one ends, with every flag off.
     * @param requestBody
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static appendTimeframeApiV1AdminTimeframesAppendPost(
        requestBody: AdminTimeframeAppend,
    ): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/timeframes/append',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Prepend Timeframe
     * Add a timeframe before the first one, ending where it starts.
     * @param requestBody
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static prependTimeframeApiV1AdminTimeframesPrependPost(
        requestBody: AdminTimeframePrepend,
    ): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/timeframes/prepend',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Timeframe Start
     * Move a timeframe's start. The previous timeframe's end moves with it.
     * @param timeframeId
     * @param requestBody
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static setTimeframeStartApiV1AdminTimeframesTimeframeIdStartPut(
        timeframeId: number,
        requestBody: AdminTimeframeStart,
    ): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/timeframes/{timeframe_id}/start',
            path: {
                'timeframe_id': timeframeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Timeframe End
     * Move a timeframe's last day. The next timeframe's start moves with it.
     * @param timeframeId
     * @param requestBody
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static setTimeframeEndApiV1AdminTimeframesTimeframeIdEndPut(
        timeframeId: number,
        requestBody: AdminTimeframeEnd,
    ): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/timeframes/{timeframe_id}/end',
            path: {
                'timeframe_id': timeframeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Timeframe
     * Rename a timeframe, set its flags or its legacy root. Turning off visibility also removes it from navigation.
     * @param timeframeId
     * @param requestBody
     * @returns AdminTimeframe Successful Response
     * @throws ApiError
     */
    public static updateTimeframeApiV1AdminTimeframesTimeframeIdPatch(
        timeframeId: number,
        requestBody: AdminTimeframeUpdate,
    ): CancelablePromise<Array<AdminTimeframe>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/admin/timeframes/{timeframe_id}',
            path: {
                'timeframe_id': timeframeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Timeframe
     * Delete the first or last timeframe.
     * @param timeframeId
     * @returns void
     * @throws ApiError
     */
    public static deleteTimeframeApiV1AdminTimeframesTimeframeIdDelete(
        timeframeId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/timeframes/{timeframe_id}',
            path: {
                'timeframe_id': timeframeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Timeframe Assignment Report
     * Dry run: the timeframe each workstream gets from the latest legacy root that reaches it.
     * @returns TimeframeAssignmentReport Successful Response
     * @throws ApiError
     */
    public static getTimeframeAssignmentReportApiV1AdminTimeframesAssignmentGet(): CancelablePromise<TimeframeAssignmentReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/timeframes/assignment',
        });
    }

    /**
     * Download Timeframe Assignment Csv
     * The assignment report as CSV, one row per non-archived workstream.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static downloadTimeframeAssignmentCsvApiV1AdminTimeframesAssignmentCsvGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/timeframes/assignment/csv',
        });
    }

    /**
     * Apply Timeframe Assignment
     * Backfill: set each unset workstream's timeframe from the report, one committed batch at a time.
     *
     * It never overwrites a timeframe that's already set. Each batch's changes are
     * in the workstream audit log under its batch ID, so a batch can be reverted.
     * @param requestBody
     * @returns TimeframeAssignmentApplyResult Successful Response
     * @throws ApiError
     */
    public static applyTimeframeAssignmentApiV1AdminTimeframesAssignmentApplyPost(
        requestBody: TimeframeAssignmentApply,
    ): CancelablePromise<TimeframeAssignmentApplyResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/timeframes/assignment/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Revert Timeframe Assignment Batch
     * Clear the timeframes a backfill batch set, unless they've changed since.
     * @param batchId
     * @returns TimeframeAssignmentRevertResult Successful Response
     * @throws ApiError
     */
    public static revertTimeframeAssignmentBatchApiV1AdminTimeframesAssignmentBatchesBatchIdRevertPost(
        batchId: string,
    ): CancelablePromise<TimeframeAssignmentRevertResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/timeframes/assignment/batches/{batch_id}/revert',
            path: {
                'batch_id': batchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Verify Timeframe Assignment
     * Check that every workstream under a root has its latest root's timeframe.
     * @returns TimeframeAssignmentVerifyResult Successful Response
     * @throws ApiError
     */
    public static verifyTimeframeAssignmentApiV1AdminTimeframesAssignmentVerifyGet(): CancelablePromise<TimeframeAssignmentVerifyResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/timeframes/assignment/verify',
        });
    }

}
